'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvQueuePlayNext = function AvQueuePlayNext(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h2v-2H3V5h18v8h2V5c0-1.11-.9-2-2-2zm-8 7V7h-2v3H8v2h3v3h2v-3h3v-2h-3zm11 8l-4.5 4.5L18 21l3-3-3-3 1.5-1.5L24 18z' })
  );
};
AvQueuePlayNext = (0, _pure2.default)(AvQueuePlayNext);
AvQueuePlayNext.displayName = 'AvQueuePlayNext';
AvQueuePlayNext.muiName = 'SvgIcon';

exports.default = AvQueuePlayNext;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/av/queue-play-next.js
 ** module id = 1689
 ** module chunks = 0
 **/